import React, { Component } from 'react';
import Alibar from '@alife/bc-alibar';
import ClassNames from "classnames";
import PropTypes from 'prop-types';

class AliBarComponents extends Component {

  render() {
    const { width } = this.props;
    const clswarp = ClassNames({
      "alibar-wrapper": true
    })


    return (
      <div className={clswarp}>
        <Alibar width="response" color={'white'} />
      </div>
    );
  }
}

AliBarComponents.propTypes = {
  width: PropTypes.string
};

export default AliBarComponents;

